import { render, staticRenderFns } from "./TopImage.vue?vue&type=template&id=0c5707fc&scoped=true&"
import script from "./TopImage.vue?vue&type=script&lang=js&"
export * from "./TopImage.vue?vue&type=script&lang=js&"
import style0 from "./TopImage.vue?vue&type=style&index=0&id=0c5707fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5707fc",
  null
  
)

export default component.exports